import {
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Add } from '@material-ui/icons'
import { useQuery, useMutation } from '@apollo/client'
import { useRouteMatch } from 'react-router-dom'

import useMediaPath from 'hooks/useMediaPath'
import { Q_VARIANT_MODELS } from 'graphql/query'
import { MC_VARIANT_MODEL } from 'graphql/mutations'

import Loading from 'components/Global/Loading'
import styles from '../vehicle.module.scss'

const Sdm = () => {
  const mediaPath = useMediaPath()
  const [vvrId, setVvrId] = useState()
  const [addUI, setAddUI] = useState(false)
  const [models, setModels] = useState()
  const [loading, setLoading] = useState(true)
  const [sdmzFile, setSdmzFile] = useState()

  let match = useRouteMatch()

  const { refetch } = useQuery(Q_VARIANT_MODELS, {
    variables: {
      id: parseInt(match.params.vvrId),
    },
  })

  const [call] = useMutation(MC_VARIANT_MODEL)
  const addNewSdm = () => {
    setLoading(true)
    call({
      variables: {
        sdmzFile: sdmzFile,
        vvrId: vvrId,
      },
    })
      .then(res => {
        updateModels()
      })
      .catch(err => console.log(err))
    setAddUI(false)
  }
  const updateModels = () => {
    refetch() &&
      refetch()
        .then(res => {
          setLoading(false)
          setModels(res.data.rVehicleVariant[0].model)
        })
        .catch(err => console.log(err))
  }
  useEffect(() => {
    updateModels()
    setVvrId(parseInt(match.params.vvrId))
  }, [])

  return !loading ? (
    <div>
      <div className={styles.sdmWrapper}>
        <div className={styles.sdmModelsWrapper}>
          {models &&
            models.map((model, i) => (
              <Paper key={i} className={styles.sdmCard}>
                <img
                  src={mediaPath(model.thumb[0].image)}
                  height="150px"
                  width="150px"
                />
              </Paper>
            ))}{' '}
        </div>
        <div>
          <Button
            endIcon={<Add />}
            variant="contained"
            fullWidth={false}
            color="primary"
            className={styles.newSdmButton}
            onClick={() => setAddUI(true)}
          >
            add new Sdm{' '}
          </Button>
        </div>
      </div>
      <Dialog open={addUI} onClose={() => setAddUI(false)}>
        <DialogTitle>Add New Sdm</DialogTitle>
        <DialogContent>
          {' '}
          <Button
            autoFocus
            margin="dense"
            id="model"
            label="Model"
            type="file"
            variant="contained"
            component="label"
          >
            upload Model
            <input
              type="file"
              onChange={e => {
                setSdmzFile(e.target.files.item(0))
              }}
              accept=".sdmz"
            />
          </Button>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            type="file"
            variant="contained"
            component="label"
            onClick={() => addNewSdm()}
          >
            submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  ) : (
    <Loading />
  )
}
export default Sdm
